import getConfig from 'next/config'
import LegacyFooter from './LegacyFooter'
import AEMFooter from '@src/aem-content/components/Footer'

const {
  publicRuntimeConfig: { featureFlags },
} = getConfig()

const Footer = featureFlags.aemCms ? AEMFooter : LegacyFooter

export default Footer
